// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3tjbm","actionsCol":"EnrolledClinics_actionsCol__3t7Yi"};